<template>
  <div>
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="run" v-if="p('Products.Run.View')">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.run') }}
          </div>
          <div class="label-desc">{{ $t('text.characterisation_run') }}</div>
        </div>
        <Run v-if="activeName === 'run'" />
      </el-tab-pane>
      <el-tab-pane name="analyse_runs" v-if="p('Products.Analyse Runs.View')">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.analyse_runs') }}
          </div>
          <div class="label-desc" v-html="$t('text.analyse_runs_desc')"></div>
        </div>
        <AnalyseRuns v-if="activeName === 'analyse_runs'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Run from '@/components/products/characterisation/Run'
import AnalyseRuns from '@/components/products/characterisation/AnalyseRuns'
import $ from 'jquery'
export default {
  data() {
    return {
      activeName: 'run',
      screenWidth: window.innerWidth
    }
  },
  components: {
    Run,
    AnalyseRuns
  },
  mounted: function() {
    this.activeName = this.$permission('Products.Run.View')
      ? 'run'
      : 'analyse_runs'
    window.addEventListener('resize', this.getScreenWidth)
    setTimeout(() => {
      this.toggleNavArrow()
      if (this.screenWidth <= 1023) {
        this.listenNavBtnClick()
      }
    }, 50)
  },
  watch: {
    activeName() {
      this.toggleNavArrow()
    }
  },
  methods: {
    listenNavBtnClick() {
      var nextBtn = document.getElementsByClassName('el-tabs__nav-next')
      nextBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-next').hide()
          $('.el-tabs__nav-prev').show()
        },
        true
      )
      var prevBtn = document.getElementsByClassName('el-tabs__nav-prev')
      prevBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-prev').hide()
          $('.el-tabs__nav-next').show()
        },
        true
      )
    },
    toggleNavArrow() {
      if (this.activeName === 'analyse_runs') {
        $('.el-tabs__nav-next').hide()
      } else {
        $('.el-tabs__nav-next').show()
      }
      if (this.activeName === 'run') {
        $('.el-tabs__nav-prev').hide()
      } else {
        $('.el-tabs__nav-prev').show()
      }
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  }
}
</script>
